import { render, staticRenderFns } from "./resourceConfig.vue?vue&type=template&id=275411f4&scoped=true"
import script from "./resourceConfig.vue?vue&type=script&lang=js"
export * from "./resourceConfig.vue?vue&type=script&lang=js"
import style0 from "./resourceConfig.vue?vue&type=style&index=0&id=275411f4&prod&lang=less&scoped=true"
import style1 from "./resourceConfig.vue?vue&type=style&index=1&id=275411f4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275411f4",
  null
  
)

export default component.exports